import React, { useState } from 'react'
import { Card, Form, Input, Button, message } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { useNavigate, Link } from 'react-router-dom'
import apiClient from '../../api/client'
import './Auth.css'

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const onFinish = async (values: any) => {
    setLoading(true)
    try {
      await apiClient.post('/auth/forgot-password', values)
      setSent(true)
      message.success('重置链接已发送到您的邮箱')
    } catch (error: any) {
      message.error(error.response?.data?.message || '发送失败')
    } finally {
      setLoading(false)
    }
  }

  if (sent) {
    return (
      <div className="auth-page">
        <Card className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">邮件已发送</h1>
            <p className="auth-subtitle">请查看您的邮箱并按照说明重置密码</p>
          </div>
          <Button type="primary" block onClick={() => navigate('/auth/login')}>
            返回登录
          </Button>
        </Card>
      </div>
    )
  }

  return (
    <div className="auth-page">
      <Card className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title">忘记密码</h1>
          <p className="auth-subtitle">请输入您的邮箱地址</p>
        </div>

        <Form
          name="forgot-password"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '邮箱格式不正确' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="邮箱" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              发送重置链接
            </Button>
          </Form.Item>
        </Form>

        <div className="auth-footer">
          <Link to="/auth/login">返回登录</Link>
        </div>
      </Card>
    </div>
  )
}

export default ForgotPassword

